import BaseComponent from "@js/components/base_component.jsx";

// Read-only display of the linked URL Domain's HTTPS/TLS certificate status on
// the Sending Domain and Shared Tracking Domain view pages. It reuses the same
// categorization (icon + text) shown on the URL Domains index. A dash is shown
// when there is no linked URL Domain yet (DNS not verified) or no status is
// available.
class EuiUrlDomainCertStatus extends BaseComponent {

  render() {
    const status = this.props.tls_cert;

    return (
      <FieldContainer labelText={ I18n.t("labels.url_domain_tls_cert") }>
        { status
          ? <span className={ status.text_class }><i className={ "fa fa-" + status.icon } /> { status.tooltip }</span>
          : <span className="text-muted">&mdash;</span>
        }
      </FieldContainer>
    );
  }

}

export default EuiUrlDomainCertStatus;
